import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../contexts/AuthContext';
import { UserRole } from '../types/auth';

interface RoleBasedRouteProps {
  children: React.ReactNode;
  allowedRoles: UserRole[];
  fallbackPath?: string;
}

const RoleBasedRoute: React.FC<RoleBasedRouteProps> = ({ 
  children, 
  allowedRoles, 
  fallbackPath = '/' 
}) => {
  const user = useUser();
  // If no user or user role not allowed, redirect
  if (!user || !allowedRoles.includes(user.role)) {
    return <Navigate to={fallbackPath} replace />;
  }

  // Render protected content
  return <>{children}</>;
};

export default RoleBasedRoute;